// Mock data for Kalinda Washington campaign website

export const newsArticles = [
  {
    id: 1,
    title: "Kalinda Washington Announces Run for State Assembly",
    date: "2024-12-15",
    category: "Campaign Updates",
    excerpt: "Educator and community leader brings 15+ years of experience to fight for public education, safety, and affordability.",
    image: "https://customer-assets.emergentagent.com/job_68a8004c-66c0-4950-9b85-3ff1d2a06ecb/artifacts/98jz46z2_IMG_6901.png",
    content: "Full article content here..."
  },
  {
    id: 2,
    title: "Community Leaders Endorse Washington Campaign",
    date: "2024-12-10",
    category: "Press Releases",
    excerpt: "Local educators and business owners rally behind Kalinda's vision for New York.",
    image: "https://customer-assets.emergentagent.com/job_68a8004c-66c0-4950-9b85-3ff1d2a06ecb/artifacts/ogxhx68k_IMG_6904.png",
    content: "Full article content here..."
  },
  {
    id: 3,
    title: "Town Hall Meeting Draws Strong Support",
    date: "2024-12-05",
    category: "Community Events",
    excerpt: "Residents voice concerns about education funding and public safety at packed community forum.",
    image: "https://customer-assets.emergentagent.com/job_68a8004c-66c0-4950-9b85-3ff1d2a06ecb/artifacts/fn3ozjqw_IMG_6902.png",
    content: "Full article content here..."
  }
];

export const issues = [
  {
    id: "education",
    title: "Supporting School Choice",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1200&q=85",
    summary: "Empower parents to choose the best schools for their children.",
    bullets: [
      "Empower parents to choose the best schools",
      "Expand high-quality charter schools",
      "Improve public schools & raise standards",
      "Focus on literacy & career readiness"
    ],
    whyItMatters: "Parents know what's best for their children. By expanding educational options and raising standards across all schools, we give every family access to quality education."
  },
  {
    id: "safety",
    title: "Public Safety",
    image: "https://images.unsplash.com/photo-1601848095050-b1f765e83937?w=1200&q=85",
    summary: "Support law enforcement and repeal dangerous policies that put communities at risk.",
    bullets: [
      "Support law enforcement and community policing",
      "Repeal dangerous bail reforms that release repeat offenders",
      "Increase penalties for violent crime and gun trafficking",
      "Prioritize victims' rights and accountability",
      "Ensure prosecutors enforce the law"
    ],
    whyItMatters: "Safe communities are the foundation of thriving neighborhoods. Our families deserve to feel secure in their homes and on their streets. We must support those who protect us and hold criminals accountable."
  },
  {
    id: "affordability",
    title: "Fight for Affordability",
    image: "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200&q=85",
    summary: "Cut taxes, reduce waste, and make New York affordable for working families.",
    bullets: [
      "Cut middle-class taxes and stop runaway spending",
      "Eliminate waste and bureaucratic bloat",
      "Lower energy costs by opposing mandates that raise utility bills",
      "Support small businesses with tax relief and fewer regulations",
      "Reduce housing costs by streamlining permits and responsible development"
    ],
    whyItMatters: "New York families are struggling with rising costs. From groceries to gas to housing, everything is more expensive. We need to cut wasteful spending, lower taxes, and make our state affordable again."
  },
  {
    id: "mental-health",
    title: "Mental Health",
    image: "https://images.unsplash.com/photo-1576091160399-112ba8d25d1d?w=1200&q=85",
    summary: "Expand access to mental health services and treatment capacity for all New Yorkers.",
    bullets: [
      "Expand access, especially for kids, veterans, and seniors",
      "Increase inpatient and crisis-treatment capacity",
      "Improve coordination between hospitals, courts, and social services",
      "Support mental health resources for first responders",
      "Focus on treatment and recovery"
    ],
    whyItMatters: "Mental health challenges affect families across our community. By expanding treatment options and improving care coordination, we can help those in crisis get the support they need."
  }
];

export const volunteerInterests = [
  "Canvassing",
  "Phone Banking",
  "Event Support",
  "Data Entry",
  "Host Events",
  "Yard Signs"
];
